const isBlockedByOrigin = store =>
  !store.state.appConfig.availableHostNames.includes(window.location.hostname);

export default isBlockedByOrigin;
